import React from "react";
import "../styles/Header.css";

export default function Header() {
  return (
    <header id="header" class="fixed-top">
      <div class="container d-flex align-items-center justify-content-lg-between">
        <a href="../index.html" class="logo me-auto me-lg-0">
          <img
            src="../assets/img/gokijany-logo-nobg.png"
            alt=".."
            class="img-fluid"
          />
        </a>

        <nav id="navbar" class="navbar order-last order-lg-0">
          <ul>
            <li>
              <a class="nav-link scrollto active" href="../index.html#hero">
                Home
              </a>
            </li>
            <li>
              <a class="nav-link scrollto" target="_blank" href="./about.html">
                About Us
              </a>
            </li>
            <li class="dropdown">
              <a href="/">
                <span>Projects</span> <i class="bi bi-chevron-down"></i>
              </a>
              <ul>
                <li class="dropdown">
                  <a href="./climate/index.html">
                    <span>Climate</span> <i class="bi bi-chevron-right"></i>
                  </a>
                  <ul>
                    <li>
                      <a href="/">Carbon Footprint</a>
                    </li>
                    <li class="dropdown">
                      <a href="/">
                        <span>Carbon Offset</span>
                        <i class="bi bi-chevron-right"></i>
                      </a>
                      <ul>
                        <li>
                          <a href="/">Forestry</a>
                        </li>
                        <li>
                          <a href="/">Agriculture</a>
                        </li>
                        <li>
                          <a href="/">Energy Efficiency</a>
                        </li>
                        <li>
                          <a href="/">Renewable Energy</a>
                        </li>
                        <li>
                          <a href="/">Waste Management</a>
                        </li>
                        <li>
                          <a href="/">Carbon Sequestration </a>
                        </li>
                      </ul>
                    </li>
                  </ul>
                </li>
                <li class="dropdown">
                  <a href="../index.html#wildlife">
                    <span>Wildlife</span> <i class="bi bi-chevron-right"></i>
                  </a>
                  <ul>
                    <li>
                      <a href="./ingonyama.html">Ingonyama</a>
                    </li>
                  </ul>
                </li>
              </ul>
            </li>
            <li>
              <a class="nav-link scrollto" href="../index.html#contact">
                Contact
              </a>
            </li>
          </ul>
          <i class="bi bi-list mobile-nav-toggle"></i>
        </nav>

        <a href="#about" class="section_btn scrollto">
          Get Quote
        </a>
      </div>
    </header>
  );
}
